import React, {
  useContext,
} from 'react';

import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { Button } from '../../../../components';

import {
  CALC_MODE_INGREOS_MENSUALES,
} from '../../../../constants';
import { convertirAMoneda } from '../../../../utils/currency';

import { FooterTextPerfilador } from '../FooterTextPerfilador';
import { PerfiladorInput } from '../PerfiladorInput';
import { ConditionAmmountList } from '../ConditionsAmmountList';
import { TabsContext } from '../../../../context/tabs/tabsContext';
import { usePerfilador } from '../../../../hooks/usePerfilador';

import useStyles from './useStyles';

export const PerfiladorIngresosMensuales = ({ onSubmit, showFooter, buttonTitle }) => {
  const classes = useStyles();
  const { tabsExtraClasses } = useContext(TabsContext);

  const {
    inputValue: valueIngresos,
    inputNumber: valueIngresosNumber,
    plazoNumber,
    engancheNumber = 0,
    percentageEnganche = 0,
    propietyValue = 0,
    montoCredito = 0,
    pagoMensual = 0,
    montoGastosEscritura = 0,
    onChange,
  } = usePerfilador({ calcMode: CALC_MODE_INGREOS_MENSUALES, useDesembolsoMode: true });

  const inputData = {
    label: '',
    value: '',
    placeHolder: '$1,000,000',
    required: true,
    type: 'currency',
    disabled: false,
    endAdornment: false,
    hideLabel: true,
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const storageData = {
      importe: montoCredito,
      meses: plazoNumber * 12,
      aforo: (montoCredito / propietyValue).toFixed(4),
      enganche: engancheNumber,
      year: plazoNumber,
      plazo: `${plazoNumber} años`,
      percentageEnganche,
      mensualidad: pagoMensual,
      montoGastosEscritura,
      propietyValue,
      propietyValueCurrency: convertirAMoneda(propietyValue),
      ingresos: valueIngresosNumber,
    };
    onSubmit({
      storageData,
      event,
    });
  };

  const conditionsAmmountData = [
    {
      label: 'Pago mensual:',
      ammountNumber: pagoMensual,
    },
    {
      label: 'Monto del crédito:',
      ammountNumber: montoCredito,
    },
    {
      label: 'Precio del inmueble:',
      ammountNumber: propietyValue,
    },
  ];

  return (
    <>
      <Grid
        container
        spacing={2}
        className={clsx(classes.container, {
          [tabsExtraClasses?.gridContainer]: tabsExtraClasses.gridContainer,
        })}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          className={clsx(classes.grid, {
            [tabsExtraClasses?.gridLeft]: tabsExtraClasses?.gridLeft,
          })}
        >
          <PerfiladorInput
            titleLabel="Tus ingresos mensuales:"
            disabled={inputData.disabled}
            hideLabel={inputData.hideLabel}
            label={inputData.label}
            placeHolder={inputData.placeHolder}
            required={inputData.required}
            type={inputData.type}
            value={valueIngresos}
            onChange={onChange}
            classes={{
              input: clsx(classes.input, {
                [tabsExtraClasses?.input]: tabsExtraClasses.input,
              }),
              title: clsx(classes.title, {
                [tabsExtraClasses?.title]: tabsExtraClasses.title,
              }),
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          className={clsx(classes.gridRight, {
            [tabsExtraClasses?.gridRight]: tabsExtraClasses.gridRight,
          })}
        >
          <Box className={classes.textConditions}>
            <Typography className={clsx(classes.subtitleConditions, {
              [tabsExtraClasses?.subtitleConditions]: tabsExtraClasses.subtitleConditions,
            })}
            >
              Condiciones estimadas
            </Typography>
          </Box>
          <ConditionAmmountList
            items={conditionsAmmountData}
            customTitleClassName={tabsExtraClasses?.titleClassName}
            customValueClassName={tabsExtraClasses?.valueClassName}
          />
        </Grid>

      </Grid>
      <Box className={classes.btnContainer}>
        <Button
          className={clsx(classes.btn, {
            [tabsExtraClasses?.btn]: tabsExtraClasses.btn,
          })}
          onClick={handleSubmit}
        >
          {buttonTitle}
        </Button>
      </Box>
      {showFooter && <FooterTextPerfilador />}
    </>
  );
};

PerfiladorIngresosMensuales.propTypes = {
  onSubmit: PropTypes.func,
  buttonTitle: PropTypes.string,
  showFooter: PropTypes.bool,
};

PerfiladorIngresosMensuales.defaultProps = {
  onSubmit: () => {},
  buttonTitle: '',
  showFooter: false,
};
